import React from "react";
import languages from "../../../data/languages";

export const languageTemplate = {
  content: "",
  language: "",
  title: "",
};

const Translations = ({
  className = "row",
  translations,
  previewImages,
  onChange,
  onChangeImage
}) => {
  return (
    <div className={className}>
      {Object.keys(languages)
        .map(lang => {
          const languageItem = translations ? translations.find(i => i.language === lang) : {};
          return (
            <div key={lang} className="col-4">
              <label>{languages[lang]}</label>

              <div className="form-group">
                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={languageItem.title || ""}
                  onChange={ev => onChange(lang, "title", ev.target.value)}
                  placeholder="Title"
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control form-control-sm"
                  value={languageItem.content || ""}
                  onChange={ev => onChange(lang, "content", ev.target.value)}
                  placeholder="Content"
                />
              </div>
              <div className="col-12">
                <label>Image</label>
                <input
                  className="form-control"
                  accept="image/*"
                  type="file"
                  name="image"
                  placeholder="Upload Image"
                  onChange={(ev) => onChangeImage(lang, ev)}
                />
                {previewImages[lang] && previewImages[lang].preview && (
                  <div className="mb-3 text-center">
                    <img
                      src={previewImages[lang].preview}
                      alt="Preview"
                      className="img-thumbnail"
                      style={{
                        maxWidth: "100%",
                        width: "auto",
                        marginTop: 20
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default React.memo(Translations);



// WEBPACK FOOTER //
// ./src/views/pages/news/translations.js